import { BreakLevel } from '@decisions/server/DecisionsFramework/BreakLevel';
import { ValidationSummary } from 'utils/ValidationUtils';

/**
 * Get reusable class name for validation
 * @param props to evaluate
 * @param ignoreValid true to avoid returning an explicitly "valid" classname.
 * This defaults to true, because we seldom highlight things green when valid
 */
export function getValidationTextClass(props?: ValidationSummary, ignoreValid = true) {
  if (!props) {
    return '';
  }
  switch (props.worstLevel) {
    case BreakLevel.Fatal:
      return 'dpc-validation-text--error';
    case BreakLevel.Warning:
      return 'dpc-validation-text--warn';
    default:
      return ignoreValid ? '' : 'dpc-validation-text--valid';
  }
}

/**
 * Get reusable class name for validation
 * @param props to evaluate
 * @param ignoreValid true to avoid returning an explicitly "valid" classname.
 * This defaults to true, because we seldom highlight things green when valid
 */
export function getValidationOutlineClass(props?: ValidationSummary, ignoreValid = true) {
  if (!props) {
    return '';
  }
  switch (props.worstLevel) {
    case BreakLevel.Fatal:
      return 'dpc-validation-outline--error';
    case BreakLevel.Warning:
      return 'dpc-validation-outline--warn';
    default:
      return ignoreValid ? '' : 'dpc-validation-outline--valid';
  }
}

/**
 * Get reusable class name for validation
 * @param props to evaluate
 * @param ignoreValid true to avoid returning an explicitly "valid" classname.
 * This defaults to true, because we seldom highlight things green when valid
 */
export function getValidationUnderlineClass(props?: ValidationSummary, ignoreValid = true) {
  // ignoreValid defaults to true, because we seldom highlight things green when valid
  if (!props) {
    return '';
  }
  switch (props.worstLevel) {
    case BreakLevel.Fatal:
      return 'dpc-validation-underline--error';
    case BreakLevel.Warning:
      return 'dpc-validation-underline--warn';
    default:
      return ignoreValid ? '' : 'dpc-validation-outline--valid';
  }
}

export function getHasValidationErrorClass(props?: ValidationSummary) {
  return props && props.reasons.length ? 'dpc-has-validation-error' : '';
}
